import { ResolveFn } from '@angular/router';
import { ensureHolidays } from '../../../utils/capacity.utils';

export const dashboardMaintenanceResolver: ResolveFn<void> = async () => {
  await ensureHolidays();
};
